var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"dir":_vm.localDisplayLang === 'ara' ? 'rtl' : 'ltr'}},[(!_vm.planSelected)?_c('overlay'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }